/**
 *Angular module*/
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
/**
 *Components*/
import {DashboadDefaultComponent} from './dashboad-default/dashboad-default.component';
/**
 *Global*/
import {routerOutlet} from '../../global';

const routes: Routes = [
    {
        path: '',
        component: DashboadDefaultComponent,
        outlet: routerOutlet['dashboard'],
        data: {
            breadcrumb: 'DASHBOARD.LABEL',
            icon: 'nav-icon i-Bar-Chart',
            status: true
        }
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DashboardRoutingModule {
}
